import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import { Draggable } from 'react-beautiful-dnd'
import { Creatable } from 'react-select'

class TableColumn extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { column, paging } = nextProps

    if (column !== this.props.column) return true
    if (paging !== this.props.paging) return true
    if (nextState !== this.state) return true
    return false
  }

  renderDropdown(column) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              {/*<li onClick={() => this.setState({showDropdown: false})}>Rename instrument</li>*/}
              <li onClick={() => this.setState({showDropdown: false}, () => {
                this.props.deleteRiderColumn(column.id)
              })}>Remove this column</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderEmptyTableColumn(column, paging, availableColumnTypes) {
    const { view } = this.props

    if (view.editable !== true) return null

    return (
      <div className="table-column" style={{minWidth: `${100/paging.size}%`, maxWidth: `${100/paging.size}%`}}>
        <div className="select-form">
          <div className="select-form-escape" onClick={() => this.props.removeRiderColumn()} />

          <div className="select-form-fields">
            <Creatable
              autoFocus={true}
              openOnFocus={true}
              className="select-form-field"
              value={undefined}
              valueKey="id"
              labelKey="title"
              clearable={false}
              placeholder={`Select or type for custom`}
              onChange={(selectedItem) => this.props.createRiderColumn({title: selectedItem.title, type: selectedItem.type.slug, position: column.position})}
              promptTextCreator={(label) => `Add custom "${label}"`}
              onNewOptionClick={(value) => this.props.createRiderColumn({title: value.title, type: 'custom', position: column.position})}
              noResultsText={`Type to add custom`}
              options={availableColumnTypes} />
          </div>
        </div>
      </div>
    )
  }

  renderTableColumn(column) {
    const { view } = this.props

    return (
      <Draggable draggableId={column.id} isDragDisabled={!view.editable} type="column">
        {(provided, snapshot) => (
          <div className="table-column" style={{minWidth: `${100/this.props.paging.size}%`, maxWidth: `${100/this.props.paging.size}%`}}>
            <div className="table-column--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle}
              {...provided.dragHandleProps} >
              {
                view.editable
                ? <div className="table-column-handle" />
                : null
              }

              {column.title}

              {
                view.editable
                ? this.renderDropdown(column)
                : null
              }
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const { column, paging, availableColumnTypes } = this.props

    return column.id !== undefined
    ? this.renderTableColumn(column)
    : this.renderEmptyTableColumn(column, paging, availableColumnTypes)
  }
}

TableColumn.propTypes = {
  view: PropTypes.object,
  column: PropTypes.object,
  paging: PropTypes.object,
  availableColumnTypes: PropTypes.array,
  removeRiderColumn: PropTypes.func,
  createRiderColumn: PropTypes.func,
  deleteRiderColumn: PropTypes.func
}

TableColumn.defaultProps = {
  view: {},
  column: {},
  paging: {},
  availableColumnTypes: [],
  removeRiderColumn: function() {},
  createRiderColumn: function() {},
  deleteRiderColumn: function() {}
}

export default TableColumn



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-table/table-column.js